import { render, staticRenderFns } from "./SendSmsPostacell.vue?vue&type=template&id=61a3f7b5&scoped=true"
import script from "./SendSmsPostacell.vue?vue&type=script&lang=js"
export * from "./SendSmsPostacell.vue?vue&type=script&lang=js"
import style0 from "./SendSmsPostacell.vue?vue&type=style&index=0&id=61a3f7b5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a3f7b5",
  null
  
)

export default component.exports